export const NOTE_VIEW_ERRORS = {
  DEFAULT: '',
  NOT_FOUND: 'Note not found',
  PARSE_ERROR: 'Failed to convert to html',
};
